import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {Mutation} from 'react-apollo';
import {Button} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import ConfirmModal from '../../../common/components/ConfirmModal';
import Error from '../../../common/components/Error/Error';
import FlexRow from '../../../common/components/layout/FlexRow';
import gql from 'graphql-tag';
import UpdateProduct from './UpdateProduct';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {flowRight as compose} from 'lodash';

const GRAPHQL_MUTATION_DELETE_PRODUCT = gql`
  mutation deleteProduct($productId: ID!) {
    deleteProduct(productId: $productId)
  }
`;

const ProductActions = ({t, product}) => {
  return (
    <FlexRow>
      <div>
        <UpdateProduct product={product} />
      </div>
      <div>
        <Mutation
          mutation={GRAPHQL_MUTATION_DELETE_PRODUCT}
          refetchQueries={['products']}
          variables={{productId: product.id}}
        >
          {(mutation) => (
            <ConfirmModal
              title={t('delete')}
              mutation={mutation}
              displayError={() => <Error error={t('errorUpdating')}/>}
              size={'sm'}
              confirmBtn={'yes'}
              cancelBtn={'no'}
            >
              {askConfirmation => (
                <div className="btn-disable">
                  <Button className="btn-update btn-update-disable"
                    onClick={askConfirmation}>
                    <FontAwesomeIcon icon={faTimes} color={'red'} size="sm"/>
                  </Button>
                </div>
              )}
            </ConfirmModal>
          )}
        </Mutation>
      </div>
    </FlexRow>
  );
};

ProductActions.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('products'),
)(ProductActions);
